import React, { useRef, useState } from "react";
import Cobber from "../../Assets/Projects/Cobber.png";
import CobberDriver from "../../Assets/Projects/CobberDriver.png";
import CryptoTravel from "../../Assets/Projects/CryptoTravel.png";
import Bondex from "../../Assets/Projects/Bondex.png";
import Pirayo from "../../Assets/Projects/pirayo2.png";
import Peaueclat from "../../Assets/Projects/Peaueclat.png";
import TravelAgency from "../../Assets/Projects/TravelAgency.png";
import CICDCertificate from "../../Assets/Projects/CICD.jpg";
import NodeCertificate from "../../Assets/Projects/NodejsCerti.jpeg";
import JsHackerRank from "../../Assets/Projects/js-hackerrank.png";
import SoftwareProcess from "../../Assets/Projects/SoftwareProcess.png";
import ClientRequirments from "../../Assets/Projects/ClientRequirments.png";
import AwsCertificate from "../../Assets/Projects/aws-certificate.jpeg";

const socialLinks = [
  { id: "GH", url: "https://github.com/mmaazy03", label: "GitHub" },
  { id: "LI", url: "https://www.linkedin.com/in/maazy/", label: "LinkedIn" },
  { id: "IG", url: "https://www.instagram.com/maaz.siddiquie?igsh=MTl3aGEwZ3N1ZjRjZQ==", label: "Instagram" },
];

const skills = [
  "JavaScript",
  "TypeScript",
  "React",
  "React Native",
  "Node.js",
  "Express",
  "MongoDB",
  "Redux",
  "Firebase",
  "Heroku",
  "Vercel",
  "AWS",
  "App Store",
  "Google Play",
  "Supabase",
  "Redis",
  "Git",
];

const tools = ["VS Code", "GitHub", "Figma", "Postman", "Slack", "Xcode", "Android Studio", "Notion", "Bitbucket", "Swagger", "CI/CD Pipeline", "JIRA", "Asana"];

const jobs = [
  {
    company: "Next Generation Innovations",
    role: "Senior Software Engineer II",
    dates: "Dec 2023 - Present",
    points: [
      "Promoted to Team Lead within 12 months, based on delivery performance and ownership of a mission-critical logistics platform, used by 2,000+ enterprise users",
      "Led a 5-person engineering team split across Pakistan and the US, implemented structured delivery and communication processes that reduced revision cycles, accelerated feature sign-offs, and improved build stability",
      'Brought down crashes from 8% to 2%. Led a full frontend architecture modernization in 2 months, reducing memory-related crashes, improving overall application load time, scalable codebase with better error handling. The client personally recognized the improvement: "The app feels genuinely faster."',
      "Resolved a platform-critical crash impacting 30% of the users in the POD (Proof of Delivery) module. Restored core logistics workflow and improved crash-free sessions from 50% to 98%",
      'Reduced post-release defects by improving QA and code review standards across the teams, shifting the mindset from "does it meet requirements" to "how will users experience this", resulting in catching bugs earlier and trimming down post-release firefighting',
      "Cut rework by ~25% by directly collaborating with stakeholders to lock requirements upfront, aligning the engineering team with business goals",
      "Accountable for end-to-end reliability, stability, and production delivery of the enterprise logistics application operating in real-world environments",
    ],
  },
  {
    company: "Tafsol Technologies",
    role: "Senior Software Engineer",
    dates: "Feb 2022 - Dec 2023",
    points: [
      "Contributed to 20% increase in sales, shipped the first MVP in under 3 months, earning the trust of the same client who commissioned a second application, and the portfolio helped onboard two additional ride-hailing clients",
      "Took 5 interns from zero to shipping production-ready applications in 4 months, and conducted weekly JavaScript and React sessions. By the end, every one of them was delivering end-to-end independently",
      "Cut project kick-off time by 40%, designed React Native boilerplate which got rid of repetitive setup work every time a new project was onboarded. Later on, that boilerplate became the standard template that the entire team built on",
      "Effortless context switching across multiple projects, worked with the backend team to design and implement an MERN stack architecture, adopted company-wide, with pre-configured setup and 3rd party libraries giving every project a consistent and scalable foundation",
      "Cut onboarding time by 25%, implemented an agile SDLC process so new hires or developers could contribute and be hands-on as early as possible",
    ],
  },
  {
    company: "Bondex",
    role: "Mobile App Developer",
    dates: "Jun 2021 - Jan 2022",
    points: [
      "Worked on a mobile app that grew to 50K+ users, started as a crypto mining wallet, and then later expanded into a LinkedIn-style job posting and hiring platform, as part of a 10+ engineers international remote team",
      "Built 12+ fully functional screens from scratch in 2 days, owned the entire module independently, and delivered it under a tight deadline",
      "Handled community support on Discord, became the go-to person for issues users faced whenever a new feature was rolled out",
    ],
  },
  {
    company: "Xord",
    role: "Web & Mobile Developer",
    dates: "Jun 2020 - Jun 2021",
    points: [
      "Built a full attendance system from scratch using NextJS, NodeJS, and ExpressJS, my first hands-on backend project marking the start of learning MERN Stack",
      "Translated mobile app designs into fully functional React Native applications delivered to clients",
      "Converted UI/UX mockups into production-ready web pages using NextJS and JavaScript across multiple projects",
    ],
  },
  {
    company: "PanaCloud",
    role: "Junior Developer",
    dates: "Jan 2019 - Jun 2019",
    points: [
      "Started as an intern with the learning of ReactJS, JavaScript, and TypeScript",
      "Built UI/UX designs for an e-commerce website using ReactJS with TypeScript",
      "Owned end-to-end QA and testing of the full e-commerce platform before deployment",
    ],
  },
];

const projects = [
  {
    id: "proj-crypto-travel",
    name: "Crypto Travel",
    image: CryptoTravel,
    desc: "Developed a scalable flight booking platform enabling users to search, compare, and reserve flights in real time with integrated secure payment processing and reservation management. The platform was designed to deliver a fast, reliable, and seamless booking experience while supporting operational efficiency and customer convenience.",
    tech: ["Next Js", "Javascript", "Node Js", "Express Js", "Stripe", "Redis", "MongoDB", "Railway", "Vercel"],
  },
  {
    id: "proj-cobber",
    name: "Cobber",
    image: Cobber,
    desc: "Built a peer-to-peer logistics platform focused on simplifying the transportation of large second-hand items through real-time delivery tracking, driver coordination, and secure payment workflows. The platform improved operational transparency and streamlined the delivery experience for buyers, sellers, and drivers.",
    tech: ["React Native", "Maps", "Live Location Tracking", "Push Notification", "Sockets", "AppStore/PlayStore Deployment", "Stripe Payment"],
  },
  {
    id: "proj-cobber-driver",
    name: "Cobber Driver",
    image: CobberDriver,
    desc: "Developed the driver-side logistics application enabling delivery partners to manage routes, track deliveries in real time, receive trip updates, and process earnings efficiently. The platform was designed to support scalable driver operations and improve delivery coordination across the network.",
    tech: ["React Native", "Google Maps", "Live Location Tracking", "Push Notification", "Sockets", "AppStore/PlayStore Deployment", "Stripe Payment"],
  },
  {
    id: "proj-bondex",
    name: "Bondex",
    image: Bondex,
    desc: "Contributed to the development of a mobile-first professional networking platform designed to modernize talent discovery, referral-based recruitment, and community-driven career growth. The platform focused on scalable social engagement, monetized referrals, and seamless cross-platform mobile experiences.",
    tech: ["React Native", "Expo", "React JS", "Firebase", "AppStore/PlayStore Deployment", "Stripe Payment", "Social media integration"],
  },
  {
    id: "proj-pirayo",
    name: "Pirayo",
    image: Pirayo,
    desc: "Built a scalable ride-hailing platform integrating live location tracking, real-time trip updates, and mapping services to optimize transportation workflows and improve rider-driver coordination. The platform focused on delivering a reliable, efficient, and user-friendly mobility experience.",
    tech: ["React Native", "Google Maps", "Live Location Tracking", "Push Notification", "Sockets", "AppStore/PlayStore Deployment", "Stripe Payment"],
  },
  {
    id: "proj-metal-cards",
    name: "Custom Metal Credit & Debit Cards",
    image: Peaueclat,
    desc: "Developed a custom card personalization platform enabling users to transform standard debit and credit cards into premium branded metal and wooden cards through an interactive customization experience, secure payment integration, and streamlined order management workflows.",
    tech: ["Next-JS", "Javascript", "React", "Firebase", "Stripe"],
  },
  {
    id: "proj-lead-generation",
    name: "Lead Generation",
    image: TravelAgency,
    desc: "Developed a lead generation and management platform for a travel agency to streamline customer acquisition, automate quotation workflows, and improve operational efficiency. The solution simplified lead tracking, accelerated response times, and optimized the overall sales management process.",
    tech: ["React Native", "Javascript", "Node js", "Express js", "MongoDB"],
  },
];

const certs = [
  { id: "cert-node", title: "Node.js, Express, MongoDB", image: NodeCertificate },
  { id: "cert-cicd", title: "Master CI/CD for react native", image: CICDCertificate },
  { id: "cert-js", title: "JavaScript Certificate", image: JsHackerRank },
  { id: "cert-software-process", title: "Software Processes and Agile Practices", image: SoftwareProcess },
  { id: "cert-client-requirements", title: "Client Needs and Software Requirements", image: ClientRequirments },
  { id: "cert-aws", title: "AWS Fundamentals: Going Cloud-Native", image: AwsCertificate },
];

function Home() {
  const projectsTrackRef = useRef(null);
  const certsTrackRef = useRef(null);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const onSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setStatus(null);

    const payload = {
      access_key: "210d9726-10fa-459c-bf2f-f8a61f6bef1f",
      ...formData,
      botcheck: "",
    };

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(payload),
      });

      const json = await response.json();
      if (json.success) {
        setStatus("success");
        setFormData({ name: "", email: "", message: "" });
      } else {
        setStatus("error");
      }
    } catch (error) {
      setStatus("error");
    } finally {
      setLoading(false);
    }
  };

  const scrollTrack = (ref, dir, offset) => {
    const node = ref.current;
    if (!node) return;
    node.scrollBy({ left: dir * offset, behavior: "smooth" });
  };

  return (
    <main className="portfolio-shell">
      <section id="home" className="section hero-section section-divider">
        <div className="hero-grid-overlay"></div>

        <div className="hero-copy">
          <div className="status-pill">
            <span className="status-dot"></span>
            CURRENTLY BUILDING @ NEXT GENERATION INNOVATIONS
          </div>
          <p className="mono-eyebrow">// SENIOR SOFTWARE ENGINEER - KARACHI, PK</p>
          <h1 className="hero-title">
            Muhammad
            <br />
            Maaz
          </h1>
          <p className="hero-subhead">Dedicated to building applications that users love and businesses rely on.</p>

          <div className="social-row">
            <span className="social-label">Let's connect -</span>
            {socialLinks.map((item) => (
              <a key={item.id} href={item.url} aria-label={item.label} className="social-box" target="_blank" rel="noreferrer">
                {item.id}
              </a>
            ))}
          </div>
        </div>

        <div className="stats-panel-wrap">
          <div className="stats-panel">
            <div>
              <div className="stats-value">7+</div>
              <div className="stats-text">YEARS BUILDING PRODUCTION APPS</div>
            </div>

            <div className="divider-line"></div>

            <div>
              <div className="stats-value">2,000+</div>
              <div className="stats-text">ENTERPRISE USERS ON A SINGLE PLATFORM</div>
            </div>

            <div className="divider-line"></div>

            <div>
              <div className="stats-value">98%</div>
              <div className="stats-text">CRASH-FREE SESSIONS RESTORED</div>
            </div>
          </div>
        </div>
      </section>

      <section id="about" className="section section-divider about-grid">
        <div>
          <p className="section-index">01 / ABOUT</p>
          <h2 className="section-heading">About Me</h2>
          <div className="about-meta">
            Karachi, Pakistan
            <br />
            Bachelor's - Computer Information &amp; Systems Engineering, NED University
            <br />
            Outside code: travelling
          </div>
        </div>

        <div>
          <p className="about-copy">
            Hi, I am <strong>Muhammad Maaz</strong> from <strong>Karachi, Pakistan</strong>. Experienced fullstack developer with 7 years of experience developing and creating efficient and
            user-friendly mobile applications. I hold a Bachelor's degree in Computer Information &amp; Systems Engineering from NED University. My expertise spans HTML, CSS, JavaScript, Typescript,
            React-Native, ReactJS, NodeJS, Express, MongoDB (MERN). Throughout my career, I've excelled in collaborating with designers and product managers to deliver high-quality products on time. I
            thrive on solving complex problems and am dedicated to delivering exceptional results that exceed expectations. My experience includes working closely with international clients, adapting
            to project requirements seamlessly.
          </p>
          <p className="about-copy">Apart from coding, some other activities that I love to do! Travelling.</p>

          <blockquote className="pull-quote">
            "What stops you from doing this?"
            <span>- Maaz</span>
          </blockquote>
        </div>
      </section>

      <section id="skills" className="section section-divider">
        <p className="section-index">02 / SKILLS</p>
        <h2 className="section-heading">Skills &amp; Expertise</h2>

        <div className="chip-grid chip-grid-large">
          {skills.map((skill) => (
            <span key={skill} className="chip chip-primary">
              {skill}
            </span>
          ))}
        </div>

        <p className="section-index section-index-top-gap">TOOLS OF INNOVATION</p>
        <div className="chip-grid">
          {tools.map((tool) => (
            <span key={tool} className="chip chip-secondary">
              {tool}
            </span>
          ))}
        </div>
      </section>

      <section id="experience" className="section section-divider">
        <p className="section-index">03 / EXPERIENCE</p>
        <h2 className="section-heading">My Work Experience</h2>

        <div className="timeline-list">
          {jobs.map((job) => (
            <article key={`${job.company}-${job.dates}`} className="timeline-item">
              <div className="timeline-rail">
                <div className="timeline-dot"></div>
                <div className="timeline-line"></div>
              </div>

              <div>
                <p className="timeline-date">{job.dates}</p>
                <h3 className="timeline-company">{job.company}</h3>
                <p className="timeline-role">{job.role}</p>

                <ul className="timeline-points">
                  {job.points.map((point) => (
                    <li key={point}>{point}</li>
                  ))}
                </ul>
              </div>
            </article>
          ))}
        </div>
      </section>

      <section id="projects" className="section section-divider">
        <p className="section-index">04 / PROJECTS</p>
        <h2 className="section-heading">Project Driven Solutions</h2>
        <p className="section-subhead">Here are a few projects I've worked on recently</p>

        <div ref={projectsTrackRef} className="card-track card-track-projects">
          {projects.map((project) => (
            <article key={project.id} className="project-card project-card-track-item">
              <img src={project.image} alt={project.name} className="project-image" />
              <div className="project-body">
                <h3>{project.name}</h3>
                <p>{project.desc}</p>
                <span className="tech-label">CORE TECHNOLOGIES</span>

                <div className="project-tech-grid">
                  {project.tech.map((item) => (
                    <span key={item} className="chip chip-primary chip-small">
                      {item}
                    </span>
                  ))}
                </div>
              </div>
            </article>
          ))}
        </div>

        <div className="track-controls">
          <button type="button" className="track-button" onClick={() => scrollTrack(projectsTrackRef, -1, 368)}>
            ←
          </button>
          <button type="button" className="track-button" onClick={() => scrollTrack(projectsTrackRef, 1, 368)}>
            →
          </button>
        </div>
      </section>

      <section id="certificates" className="section section-divider">
        <p className="section-index">05 / CERTIFICATES</p>
        <h2 className="section-heading">Certificates &amp; Achievements</h2>
        <p className="section-subhead">Mastering the art of innovation, one step at a time.</p>

        <div ref={certsTrackRef} className="card-track card-track-certs">
          {certs.map((item) => (
            <article key={item.id} className="certificate-card certificate-card-track-item">
              <img src={item.image} alt={item.title} className="certificate-image" />
              <h3>{item.title}</h3>
            </article>
          ))}
        </div>

        <div className="track-controls">
          <button type="button" className="track-button" onClick={() => scrollTrack(certsTrackRef, -1, 328)}>
            ←
          </button>
          <button type="button" className="track-button" onClick={() => scrollTrack(certsTrackRef, 1, 328)}>
            →
          </button>
        </div>
      </section>

      <section id="contact" className="section contact-grid">
        <div>
          <p className="section-index">06 / CONTACT</p>
          <h2 className="section-heading">Unlock Your Solutions</h2>
          <p className="contact-subhead">Feel free to get in touch with me for any inquiries or feedback!</p>

          <div className="contact-list">
            <p>
              <span>EMAIL</span>
              <a href="mailto:mmaazy03@gmail.com">mmaazy03@gmail.com</a>
            </p>
            <p>
              <span>PHONE</span>
              +92-318-3320178
            </p>
            <p>
              <span>ADDR</span>
              Karachi, Pakistan
            </p>
          </div>
        </div>

        <form className="contact-form" onSubmit={onSubmit}>
          <p className="form-title">SEND A MESSAGE</p>

          {status === "success" && <p className="form-alert form-alert-success">Message sent successfully.</p>}
          {status === "error" && <p className="form-alert form-alert-error">Something went wrong. Please try again.</p>}

          <label htmlFor="name">NAME</label>
          <input id="name" type="text" name="name" placeholder="Enter your name" value={formData.name} onChange={onChange} required />

          <label htmlFor="email">EMAIL</label>
          <input id="email" type="email" name="email" placeholder="Enter your email" value={formData.email} onChange={onChange} required />

          <label htmlFor="message">MESSAGE</label>
          <textarea id="message" name="message" rows="4" placeholder="Enter your message" value={formData.message} onChange={onChange} required />

          <button type="submit" disabled={loading}>
            {loading ? "SENDING..." : "SEND MESSAGE ->"}
          </button>
        </form>
      </section>
    </main>
  );
}

export default Home;
